import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useEmployeeForms from "../../../hooks/useEmployeeForms";
import { STATUS_COLORS, FORM_ACTION, FORM_STATUS } from "./constants";
import { getIcon } from "./iconMapping";

export default function MyForms() {
  const navigate = useNavigate();
  const { forms, pensionForms, loading, error, refetch } = useEmployeeForms();
  const [selectedForm, setSelectedForm] = useState(null);

  const handleComingSoon = () => {
    alert("Retirement & Pension Forms will be available in a future release.");
  };

  // Centralized form action handler
  const handleFormAction = (form) => {
    setSelectedForm(form);
    console.log("MyForms - handleFormAction called with form:", form);
    console.log("MyForms - form.code:", form.code);
    console.log("MyForms - form.action:", form.action);
    console.log("MyForms - form.status:", form.status);

    switch (form.action) {
      case FORM_ACTION.START:
        console.log("MyForms - Navigating to:", `/employee/forms/fill/${form.code}`);
        navigate(`/employee/forms/fill/${form.code}`);
        break;
      case FORM_ACTION.CONTINUE:
        console.log('Continuing form:', form.code);
        navigate(`/employee/forms/fill/${form.code}`);
        break;
      case FORM_ACTION.PREVIEW:
        console.log('Previewing form:', form.code);
        navigate(`/employee/forms/${form.code}/preview`);
        break;
      case FORM_ACTION.EDIT_RESUBMIT:
        console.log('Editing form:', form.code);
        navigate(`/employee/forms/fill/${form.code}`);
        break;
      default:
        console.log('Unknown action:', form.action);
    }
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex items-center justify-center py-12">
          <div className="text-gray-500">Loading forms...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex items-center justify-center py-12">
          <div className="text-red-500">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      {/* Header */}
      <div className="mb-10">
        <h1 className="text-3xl font-bold text-gray-900">My Forms</h1>

        <p className="text-gray-600 mt-2">
          Complete and manage your official employee forms.
        </p>
      </div>

      {/* Joining Forms */}
      <div className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-900">Joining Forms</h2>

        <p className="text-gray-500 mt-1 mb-6">
          Forms required during your onboarding process.
        </p>

        <div className="space-y-5">
          {forms.map((form) => {
            const Icon = getIcon(form.icon);

            return (
              <div
                key={form.id}
                className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-4">
                    <div className="h-14 w-14 rounded-lg bg-blue-50 flex items-center justify-center">
                      <Icon className="h-7 w-7 text-blue-600" />
                    </div>

                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="text-xl font-semibold text-gray-900">
                          {form.title}
                        </h3>
                        {form.is_mandatory && (
                          <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-xs font-medium">
                            Mandatory
                          </span>
                        )}
                      </div>

                      <p className="text-gray-500 mt-1">{form.description}</p>

                      <p className="text-sm text-gray-400 mt-3">{form.meta}</p>
                    </div>
                  </div>

                  <div className="flex flex-col items-end gap-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${STATUS_COLORS[form.status]}`}
                    >
                      {form.statusDisplay}
                    </span>

                    <button
                      onClick={() => handleFormAction(form)}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
                    >
                      {form.action}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Retirement & Pension Forms */}

      <div>
        <h2 className="text-2xl font-semibold text-gray-900">
          Retirement & Pension Forms
        </h2>

        <p className="text-gray-500 mt-1 mb-6">
          Forms related to retirement and pension benefits.
        </p>

        {pensionForms.map((form) => {
          const Icon = getIcon(form.icon);

          return (
            <div
              key={form.id}
              onClick={handleComingSoon}
              className="bg-white border border-dashed border-gray-300 rounded-xl p-6 cursor-pointer hover:border-blue-400 hover:shadow-md transition-all"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-4">
                  <div className="h-14 w-14 rounded-lg bg-gray-100 flex items-center justify-center">
                    <Icon className="h-7 w-7 text-gray-500" />
                  </div>

                  <div>
                    <h3 className="text-xl font-semibold text-gray-700">
                      {form.title}
                    </h3>

                    <p className="text-gray-500 mt-1">{form.description}</p>

                    <p className="text-sm text-gray-400 mt-3">{form.meta}</p>
                  </div>
                </div>

                <span className="px-4 py-2 rounded-full bg-gray-100 text-gray-600 text-sm font-medium">
                  Coming Soon
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
